module.exports = __webpack_public_path__ + "static/img/success.55f82981.svg";